import {PaymentGatewayMode} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/paymentGatewayWorkspaceCapability/domain/PaymentGateway";
import {PaymentGatewayProvider} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/paymentGatewayWorkspaceCapability/domain/PaymentGateway";
import {PaymentReferenceType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/paymentGatewayWorkspaceCapability/domain/PaymentGateway";
import {z as zod} from "zod";

export type PaymentGatewayWorkspaceCapabilityConfiguration = {
    allowedCurrencies: Array<string>;
    allowedGateways: Array<PaymentGatewayProvider>;
    allowedReferenceTypes: Array<PaymentReferenceType>;
    defaultGateway: PaymentGatewayProvider;
    gatewayMode: PaymentGatewayMode;
    sessionExpiryMinutes: number;
};

export const paymentGatewayWorkspaceCapabilityConfigurationValidator: zod.ZodType<PaymentGatewayWorkspaceCapabilityConfiguration> = zod.strictObject({
    allowedCurrencies: zod.string().array(),
    allowedGateways: zod.enum(PaymentGatewayProvider).array(),
    allowedReferenceTypes: zod.enum(PaymentReferenceType).array(),
    defaultGateway: zod.enum(PaymentGatewayProvider),
    gatewayMode: zod.enum(PaymentGatewayMode),
    sessionExpiryMinutes: zod.number().int().positive(),
});
